import styled from "styled-components";

export const NavbarWrapper = styled.div`
  flex: 0;
  border-bottom: solid 1px var(--adm-color-border);
`;

export const BodyWrapper = styled.div`
  flex: 1;
  display: flex;
  /* overflow: auto; */
  height: calc(100vh - (50px + 45px));
  /* padding: 10px; */
  /* background-color: var(--adm-color-light); */
`;

export const FooterWrapper = styled.div`
  flex: 0;
  border-top: solid 1px var(--adm-color-border);
`;
